import { combineReducers } from 'redux';
import { paycodes } from './reducers/paycodes';
import { appRoutes } from './routes';

export const initReducers = () => {
  return {
    sender: combineReducers({
      paycodes,
    })
  };
};

export const initRoutes = () => {
  return appRoutes;
};

export const initApp = (store) => {
};
